import { Object as FabricObject, Group } from 'fabric';

import { isBullet } from './groupUtils';

export const findObjectById = (objects: FabricObject[], targetId: string): FabricObject | null => {
  for (const obj of objects) {
    if (obj.id === targetId) {
      return obj;
    }
    if (isBullet(obj) && obj instanceof Group) {
      const found = findObjectById(obj.getObjects(), targetId);
      if (found) {
        return found;
      }
    }
  }
  return null;
};
